import { render, staticRenderFns } from "./ReportBoxMixSales.vue?vue&type=template&id=586cba94&"
import script from "./ReportBoxMixSales.vue?vue&type=script&lang=js&"
export * from "./ReportBoxMixSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('586cba94')) {
      api.createRecord('586cba94', component.options)
    } else {
      api.reload('586cba94', component.options)
    }
    module.hot.accept("./ReportBoxMixSales.vue?vue&type=template&id=586cba94&", function () {
      api.rerender('586cba94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/ReportBoxMixSales.vue"
export default component.exports